<template>
	<div id="global-header">
		<div class="content">
			<div class="global-nav" role="navigation" :aria-label=labels.primary>
				<div class="container-liquid-parent">
					<div class="container-liquid">
						<div class="all-sites-mobile-nav hidden-sm hidden-md hidden-lg">
							<div>
								<ul class="top-menu">
									<li class="main-link" v-if="envMode!='production'">
										<a @click="showLangChooser=true">
											<span class="icon icon-about invisible" aria-hidden="true"></span>
											<span class="">{{ labels.chooseLanguage }}</span>
										</a>
									</li>
									<li class="main-link">
										<a :href=labels.allgysites.allref target="_blank">
											<span class="icon icon-about" aria-hidden="true"></span>
											<span>{{ labels.allgysites.alllabel }}</span>
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div class="all-sites-nav" v-show="IsAuthorized">
							<div class="container">
								<div class="navbar-user">
									{{ HeaderMenuItems ? HeaderMenuItems.full_name : '' }} | {{ HeaderMenuItems ? HeaderMenuItems.user_name : '' }}
								</div>
								<ul class="top-menu">
									<li class="main-link" v-if="envMode!='production'">
										<a class="clickMe" @click="showLangChooser=true">
											<span class="icon icon-about invisible" aria-hidden="true"></span>
											<span class="">{{ labels.chooseLanguage }}</span>
										</a>
									</li>
									<li class="main-link">
										<a :href=labels.allgysites.allref target="_blank" class="clickMe">
											<span class="icon icon-about" aria-hidden="true"></span>
											<span>{{ labels.allgysites.alllabel }}</span>
										</a>
									</li>
									
									<li class="main-link">
										<router-link class="dropdown-toggle" :to="{ name: 'Logout' }">
											<span class="glyphicon glyphicon-log-out" aria-hidden="true"></span>
											<span class="menu-item-text">{{ $trans(labels.login.logoutLabel) }}</span>
										</router-link>
									</li>
								</ul>
							</div>
						</div>
						<div class="all-sites-nav" v-show="!IsAuthorized">
							<div class="container">
								<ul class="top-menu">
									
									<li class="main-link" v-if="envMode!='production'">
										<a class="clickMe" @click="showLangChooser=true">
											<span class="icon icon-about invisible" aria-hidden="true"></span>
											<span class="">{{ $trans(labels.chooseLanguage) }}</span>
										</a>
									</li>
									<li class="main-link">
										<a :href=labels.allgysites.allref target="_blank">
											<span class="icon icon-about" aria-hidden="true"></span>
											<span>{{ $trans(labels.allgysites.alllabel) }}</span>
										</a>
									</li>
									<li class="main-link">
										<router-link class="dropdown-toggle" :to="{ name: 'Login' }">
											<span class="glyphicon icon icon-gy-lock" aria-hidden="true"></span>
											<span>{{ $trans(labels.login.loginLabel) }}</span>
										</router-link>
										
									</li>
								</ul>
							</div>
						</div>
						<nav class="navbar">
							<div class="container">
								<div class="navbar-header">
									<a class="navbar-brand" v-on:click="home" :aria-label=labels.gyhomepage.gyhomepageLabel>
										<img v-if="isFleetHQIcon" src="data:image/png;base64, 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" alt="Goodyear Fleet Central">
										<img v-if="isDelaerIcon" src="data:image/png;base64, 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" alt="Goodyear Fleet Central">
										<img v-if="!isDelaerIcon && !isFleetHQIcon" src="data:image/png;base64, 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" :alt=labels.gyfleet>
									</a>
									<button type="button" class="navbar-toggle visible-xs" data-toggle="collapse" :aria-label=labels.mobileNav @click="collapseMobileMenu">
										<span class="icon-bar"></span>
										<span class="icon-bar"></span>
										<span class="icon-bar"></span>
									</button>
								</div>
								<!-- Mobile  -->
								<div class="js-navbar-collapse desktop" :class="isCollapseMobileMenu ? 'collapse in' : 'collapse'">
									<ul class="nav navbar-nav" v-if="HeaderMenuItems && HeaderMenuItems !== undefined">
										<li class="dropdown-large user">
											<a class="dropdown-toggle disabled">{{ HeaderMenuItems ? HeaderMenuItems.full_name : '' }} ({{ HeaderMenuItems ? HeaderMenuItems.user_name : '' }})</a>
										</li>
										<li class="dropdown-large">
											<a class="dropdown-toggle" v-on:click="home">{{ $trans('Home') }}</a>
										</li>
										<li class="dropdown-large"
											v-for="tab in HeaderMenuItems.tabs" 
											:key="tab.key" 
											@click="toggleMobileMenu(tab)"
											
											>
											<a
											>{{ tab.name }}</a>
											<span v-if="tab.isCollapsed == true" class="visible-xs icon-thin-arrow-right" ></span>
											<span v-else-if="tab.isCollapsed == false" class="visible-xs icon-thin-arrow-down"></span>
											<ul
												class="service-collapse" :class="tab.id==menuDropDowned ? 'collapse in' : 'collapse'">
												<li v-for="menuitem in tab.links" :key="menuitem.key">
													<a @click="followLink" v-bind:href="replaceLink(menuitem.url)" :sso-id="menuitem.sso_id" class="mobile-sub-menu clickMe">
														{{ menuitem.name }}
													</a>
												</li>
											</ul>
										</li>
										<li class="dropdown-large" v-show="IsAuthorized" v-on:click="allclose()">
											<a v-bind:href="HeaderMenuItems.my_info" class="dropdown-toggle">{{ HeaderMenuItems.my_info_name }}</a>
										</li> 
										<li class="dropdown-large" v-show="!IsAuthorized">
											<router-link :to="{ name: 'Login' }">{{ $trans(labels.login.loginLabel) }}</router-link>
											<span class="glyphicon icon icon-gy-lock" aria-hidden="true"></span>											
										</li>
										<li class="dropdown-large" v-show="IsAuthorized">
											<router-link :to="{ name: 'Logout' }">{{ $trans(labels.login.logoutLabel) }}</router-link>
											<span class="glyphicon glyphicon-log-out"></span>
										</li>
									</ul>
									<ul class="nav navbar-nav" v-else>
										<li class="dropdown-large user">
											<a class="dropdown-toggle disabled">{{ HeaderMenuItems ? HeaderMenuItems.full_name : '' }} ({{ HeaderMenuItems ? HeaderMenuItems.user_name : '' }})</a>
										</li>
										<li class="dropdown-large">
											<a class="dropdown-toggle" v-on:click="home">{{ $trans('Home') }}</a>
										</li>
										<li class="dropdown-large" v-show="!IsAuthorized">
											<router-link :to="{ name: 'Login' }">{{ $trans(labels.login.loginLabel) }}</router-link>
											<span class="glyphicon icon icon-gy-lock" aria-hidden="true"></span>											
										</li>
										<li class="dropdown-large" v-show="IsAuthorized">
											<router-link :to="{ name: 'Logout' }">{{ $trans(labels.login.logoutLabel) }}</router-link>
											<span class="glyphicon glyphicon-log-out"></span>
										</li>
									</ul>
								</div>
								<!--  -->
								<div class="collapse navbar-collapse hidden-xs desktop">
									<ul class="nav navbar-nav" v-if="HeaderMenuItems && HeaderMenuItems.tabs" > 
											<li class="dropdown-large" v-on:click="allclose()" v-if="HeaderMenuItems && HeaderMenuItems.home_name">
												<a class="dropdown-toggle" v-on:click="home" >{{ $trans('Home') }}</a>
											</li>

											<li class="dropdown-large" v-for="tab in HeaderMenuItems.tabs" :key="tab.key" v-on:click="toggle(tab.id)" >
												<a class="dropdown-toggle">{{ tab.name }}</a> 
												<div class="arrow-up" :style="{ 'display': dropDowned==tab.id ? 'block' : 'none'}" ></div>
											</li>	
											<li class="dropdown-large" v-on:click="allclose()" v-if="HeaderMenuItems && HeaderMenuItems.my_info_name">
												<a v-bind:href="HeaderMenuItems.my_info" class="dropdown-toggle">{{ HeaderMenuItems.my_info_name }}</a>
											</li> 	
									</ul>
									<ul class="nav navbar-nav" v-else > 
										<li class="dropdown-large" v-on:click="allclose()" >
											<router-link class="dropdown-toggle" :to="{ name: 'Login' }">{{ $trans('Home') }}</router-link>
										</li>
									</ul>													
								</div>
							</div> <!-- end .main-nav -->
						</nav> <!-- end .navbar -->
					</div> <!-- end .container-liquid -->
					<div class="subMenu" v-if="HeaderMenuItems && HeaderMenuItems.tabs !== undefined">
						<transition 
							mode="in-out"
							v-on:before-enter="transitionBeforeEnter"
							v-on:enter="transitionEnter"
							v-on:leave="transitionLeave"
							v-on:after-leave="transitionAfterLeave"
							
							v-bind:css="false"
							v-for="tab in HeaderMenuItems.tabs" :key="tab.key">
							<div class="dropdown-menu-large" v-if="dropDowned==tab.id" :style="{ 'display': dropDowned==tab.id ? 'block' : 'none'}">
								<div class="row">
									<div class="col-sm-4 col-md-3">
										<div class="dropdown-action">
										</div>
									</div>
									<div class="col-sm-8 col-md-9 dropdown-list-items">
										<ul class="row">
											<li 
												v-for="menuitem in tab.links" :key="menuitem.key"
												class="submenu-col col-sm-11 col-md-6 col-lg-4"
											>
												<a v-bind:href="replaceLink(menuitem.url)" @click="followLink" :sso-id="menuitem.sso_id" v-bind:target="menuitem.new_window==true ? '_blank' : '_self'" class="clickMe">
													<div class="dropdown-tile">
														<p class="dropdown-tile-title">
															{{ menuitem.name }}
															<span class="icon-thin-arrow-right"></span>
														</p>
													</div>
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</transition>
						
						<div class="close-nav-btn hidden-xs" v-on:click="allclose()" :style="{'display': dropDowned!=null ? 'block' : 'none' }"><p>{{ labels.close }}</p></div>
					</div>
				</div>
			</div>
        </div>
		<language-chooser
			@close="showLangChooser=false"
			v-if="showLangChooser"
			>

		</language-chooser>
	</div>
</template>
<script>
	import { mapGetters, mapActions } from "vuex";
	import Velocity from 'velocity-animate';
	import LanguageChooser from '@/components/LanguageChooser.vue';
	import { API_VERIFY_AUTH } from "@/core/services/api/auth.module";
	import { API_TRANSLATIONS_ACTION_LOAD } from "@/core/services/api/translations.module";

	export default {
		name: "header-menu",
		props: ["headers"],
		data() {
			return {
				isFleetHQIcon: this.UserState && this.UserState.Group == 'CUS',
				isDelaerIcon: this.UserState && this.UserState.Group == 'DLR',
				labels:
				{
					primary: "Primary Site Navigation",
					chooseLanguage: 'Choose Language',
					allgysites: {
						allref: "https://www.goodyear.com/en-US/other-goodyear-sites",
						alllabel: "All Goodyear Sites"
					},
					login:{
						loginRef: "/Membership/Login",
						loginLabel: "Login",
						logoutRef: "/Membership/Logout",
						logoutLabel: "Log Out"
					},
					gyhomepage:{
						gyhomepageRef: "/",
						gyhomepageLabel: "Back to Goodyear Homepage"
					},
					gyfleet: "Goodyear Fleet Central",
					mobileNav: "Mobile Navigation Toggle",
					close: "CLOSE"
				},
				baseUsrl:"https:localhost:44305",
				dropDowned: null,
				mouseDownLink: null,
				isCollapseMobileMenu: false,
				menuDropDowned: null,
				selectedLanguage: null,
				languages: [
					"en-US"
				],
				envMode: process.env.VUE_APP_ENV_NAME,
				showLangChooser: false,
			};
		},
		mounted() {
			document.addEventListener('headerChangeIconEvent', () => {
                //this.isFleetHQIcon = location.pathname.includes("/dashboard/fleet-central");
				this.isFleetHQIcon = this.UserState && this.UserState.Group == 'CUS';
				this.isDelaerIcon = this.UserState && this.UserState.Group == 'DLR';
			})

			//this.selectedLanguage = window.localStorage.getItem("USER_LANGUAGE");
			this.selectedLanguage = this.getTranslationsSelectedLocale;
			this.languages = this.getTranslationsLocales;
			this.isFleetHQIcon = this.UserState && this.UserState.Group == 'CUS';
			this.isDelaerIcon = this.UserState && this.UserState.Group == 'DLR';
		},
		components: {
			'language-chooser': LanguageChooser
		},
		computed: {
			//console: () => console,
			...mapGetters({
                UserState: "AppGetUser",
                IsAuthorized: "AppIsAuthenticated",
                HeaderMenuItems: "AppGetHeaderMenuItems",
				Message: "getTranslationsMessage",
				getTranslationsSelectedLocale: "getTranslationsSelectedLocale",
				getTranslationsLocales: "getTranslationsLocales"
            })
		},
		methods: {
			home(e) {
				var user = this.UserState;
				console.log(user);
				if (user.Group == "GYR" && window.app.$router.history.current.name != "business-solutions-dashboard") {
					window.app.$router.push({ name: "business-solutions-dashboard" });
					//console.log('user.Group == "GYR"');
					//console.log(user);
					//window.app.$root.$emit('show-notify', 'Help us to translate our service to local language');
				}
				if (user.Group == "SSC" && window.app.$router.history.current.name != "business-solutions-dashboard") {
					window.app.$router.push({ name: "business-solutions-dashboard" });
				}
				if (user.Group == "DLR" && window.app.$router.history.current.name != "dealer-portal-dashboard") {
					window.app.$router.push({ name: "dealer-portal-dashboard" });
				}
				if (user.Group == "WIN" && window.app.$router.history.current.name != "dealer-portal-dashboard") {
					window.app.$router.push({ name: "dealer-portal-dashboard" });
				}
				if (user.Group == "CUS" && window.app.$router.history.current.name != "fleet-central-dashboard") {
					window.app.$router.push({ name: "fleet-central-dashboard" });
				}
			},
			followLink(e) {
				e.preventDefault();
				this.$store.dispatch(API_VERIFY_AUTH)
				.then(() => {
					let followLink= e.target.closest("a");
					let ssoId = followLink.getAttribute('sso-id');
					if (followLink) {
						let url = new URL(followLink.href);
                        var a = document.createElement('a');
						if(ssoId == 1){
							a.href = followLink.href + `?mode=sso&token=${encodeURIComponent(this.UserState.GyToken)}&email=${this.UserState.Email}&source=fleet-central`;
						}
						else {
							if (url.search == "") {
								a.href = followLink.href + "?user=" + this.UserState.GyToken;
							} else {
								a.href = followLink.href + "&user=" + this.UserState.GyToken;
							}
						}
						a.target = followLink.target;
						document.body.appendChild(a);
	
						a.click();
					}
				})
			},
			transitionBeforeEnter: function (el) {
				
			},
			transitionEnter: function (el, done) {
				Velocity(el, "slideDown", { duration: 600 }, { complete: done });
			},
			transitionLeave: function (el, done) {
				Velocity(el, "slideUp", { duration: 300 }, { complete: done });

			},
			transitionAfterLeave: function (el) {
				
			},
			...mapActions([
                "logout",
				"action_admin_translations_load"
            ]),
			toggle(dropdownName) {
				
				if (this.dropDowned != dropdownName) {
					this.dropDowned = dropdownName;		
				} else {
					this.dropDowned = null;
				}
			},
			toggleMobileMenu(tab) {
				var dropdownName  = tab.id;
				if (this.menuDropDowned != dropdownName) {
					this.menuDropDowned = dropdownName;		
				} else {
					this.menuDropDowned = null;
				}
				if(tab.isCollapsed == true) {
					tab.isCollapsed = false;
				}
				else {
					tab.isCollapsed = true;
				}
			},
			allclose() {
				this.dropDowned = null;
			},
			setLanguage() {
				this.$store.dispatch(API_TRANSLATIONS_ACTION_LOAD, this.selectedLanguage)
				.then(() => {
					this.$i18n.setLocaleMessage(this.selectedLanguage, this.Message);
					this.$i18n.locale = this.selectedLanguage;
					window.localStorage.setItem("USER_LANGUAGE", this.selectedLanguage);
				}).catch(e => {
					console.log(e);
				})
				// location.search = '?lang=' + this.selectedLanguage;
			},
			replaceLink(link) {
				if (process.env.VUE_APP_REPLACE_TARGET) {
                    if (link.includes(process.env.VUE_APP_REPLACE_TARGET)) {
                        return link.replace(process.env.VUE_APP_REPLACE_TARGET, process.env.VUE_APP_REPLACE_DOMEN);
                    }
                }
				if (process.env.VUE_APP_REPLACE_TARGET_TM) {
                    if (link.includes(process.env.VUE_APP_REPLACE_TARGET_TM)) {
                        return link.replace(process.env.VUE_APP_REPLACE_TARGET_TM, process.env.VUE_APP_REPLACE_DOMEN_TM);
                    }
                }
				return link;
			},
			collapseMobileMenu() {
				this.isCollapseMobileMenu = !this.isCollapseMobileMenu;
			}
		},
		created() {
			document.addEventListener('langChooseEvent', (event) => {
				if(localStorage.getItem('USER_LANGUAGE')) {
					this.selectedLanguage = localStorage.getItem('USER_LANGUAGE');
				}
			})
			document.addEventListener('click', this.documentClicked);

		},
		destroyed() {
			document.removeEventListener('click', this.documentClicked);
		}
	};
</script>

<style  scoped>
body .navbar-toggle {
	padding: 0;
	margin-top: 10px;
}
@media only screen and (max-width: 600px) {
	body .navbar-toggle {
		margin: 0;
		padding-top: 15px;
	}
}
@media only screen and (max-width: 767px) {
	.navbar .navbar-header img {
		padding-left: 10px;
		padding-top: 15px;
		padding-bottom: 0;
	}
}
.all-sites-mobile-nav .top-menu li {
	color: #f0f0f0;
	float: left;
	padding: 4px 10px;
	margin: 0;
	font-size: 14px;
}

	.all-sites-mobile-nav .top-menu li.main-link a {
		color: #fd0;
		padding: 0;
		display: inline-block;
		text-decoration: none;
		text-transform: uppercase;
		font-family: BarlowCondensedLight,Arial,sans-serif;
		font-weight: 400;
		font-style: normal;
	}

.all-sites-mobile-nav .top-menu {
	font-weight: normal;
	font-style: normal;
	-webkit-font-smoothing: subpixel-antialiased;
	margin: 4px 0 0;
	padding: 0;
	list-style: none;
	float: right;
	width: auto;
	margin-right: 10px;
}
.all-sites-mobile-nav {
	display: block;
	height: 33px;
	background-color: rgba(0,0,0,.6);
	background-repeat: repeat;
	width: 100%;
	border-bottom: 1px solid rgba(255,255,255,0.2);
	padding: 0;
	margin: 0;
	line-height: 100%;
	overflow-y: hidden;
}
.navbar .container .navbar-header {
	padding-top: 0px;
}
/*.global-nav .navbar-brand {
padding: 0px;
padding-top: 15px;
display: inline-block;
height: auto;
}*/
.global-nav .navbar {
	margin-bottom: 0;
	padding: 0px;
	height: auto;
	min-height: none;
}

.container > .navbar-header {
	margin-right: 0px;
	margin-left: 0px;
}
.dropdown-tile-title {
	white-space: nowrap;
}
.arrow-up {
	width: 0;
	height: 0;
	border-left: 15px solid transparent;
	border-right: 15px solid transparent;
	border-bottom: 15px solid white;
	margin-left: 20px;
}
.slide-leave-active {
	-moz-transition-duration: 0.9s;
	-webkit-transition-duration: 0.9s;
	-o-transition-duration: 0.9s;
	transition-duration: 0.9s;
	-moz-transition-timing-function: ease-in;
	-webkit-transition-timing-function: ease-in;
	-o-transition-timing-function: ease-in;
	transition-timing-function: ease-in;
}

.slide-enter-active {
	-moz-transition-duration: 0.9s;
	-webkit-transition-duration: 0.9s;
	-o-transition-duration: 0.9s;
	transition-duration: 0.9s;
	-moz-transition-timing-function: ease-in;
	-webkit-transition-timing-function: ease-in;
	-o-transition-timing-function: ease-in;
	transition-timing-function: ease-in;
}

.slide-enter, .slide-leave-to {
	max-height: 0;
	overflow: hidden;
	transform: translate3d(0,0%,0);
}

.slide-enter-to, .slide-leave {
	overflow: hidden;
	transform: translate3d(0,-100%,0);
}
</style>
